import { tryParseNumber } from './dataAudit'

const isEmptyString = (v) => typeof v === 'string' && v.trim() === ''

export function applySafeFixes(rows = []) {
  const cleaned = rows
    .map((row) => {
      const out = {}
      Object.keys(row).forEach((key) => {
        const value = row[key]
        if (typeof value === 'string') {
          const trimmed = value.trim()
          if (trimmed === '') {
            out[key] = null
            return
          }
          const parsedNumber = tryParseNumber(trimmed)
          if (parsedNumber !== null) {
            out[key] = parsedNumber
            return
          }
          const parsedDate = new Date(trimmed)
          out[key] = Number.isNaN(parsedDate.getTime()) ? trimmed : parsedDate.toISOString().slice(0, 10)
          return
        }
        out[key] = value
      })
      return out
    })
    .filter((row) => Object.values(row).some((v) => v !== null && v !== undefined && !isEmptyString(v)))

  return cleaned
}
